import { render, staticRenderFns } from "./ManagePreRegister.vue?vue&type=template&id=5474c21e&scoped=true"
import script from "./ManagePreRegister.vue?vue&type=script&lang=js"
export * from "./ManagePreRegister.vue?vue&type=script&lang=js"
import style0 from "./ManagePreRegister.vue?vue&type=style&index=0&id=5474c21e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5474c21e",
  null
  
)

export default component.exports